import Cookies from 'js-cookie'
import { isAndroid,isIOS } from "@/utils/validate"

export default {
    set(key,val){
        if(window.plus&&isIOS()){
            plus.storage.setItem(key,val)
        }else{
            window.localStorage.setItem(key,val)
        }
    },
    get(key){
        if(window.plus&&isIOS()){
            return plus.storage.getItem(key)
        }else{
            return window.localStorage.getItem(key)
        }
    },
    remove(key){
        if(window.plus&&isIOS()){
            plus.storage.removeItem(key)
        }else{
            window.localStorage.removeItem(key)
        }
    },
}